import React from 'react';
import { NotificationsButton } from '../common/NotificationsButton';
import { Page } from '../common/Page';
import { ShowIfHasPermission } from '../common/PermissionElements';
import { UpdatesButton } from '../common/UpdatesButton';
import { HelpButton } from '../help/HelpButton';
import { PreferencesButton } from '../preferences/PreferencesButton';

export const AccountHeaderBlock = () =>
    <Page.HeaderBlock data-tour="header-help">
        <UpdatesButton />
        <ShowIfHasPermission requires="da:read">
            <NotificationsButton />
        </ShowIfHasPermission>
        <PreferencesButton />
        <HelpButton />
    </Page.HeaderBlock>;
